var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { defaultState } from './state';
import { DELETE_COLLECTION_CART_ITEM, FETCH_CART_ITEM_ERROR, FETCH_CART_ITEM_REQUEST, FETCH_CART_ITEM_SUCCESS, FETCH_CART_ITEMS_ERROR, FETCH_CART_ITEMS_REQUEST, FETCH_CART_ITEMS_SUCCESS, FETCH_DRAFT_ITEMS_ERROR, FETCH_DRAFT_ITEMS_REQUEST, FETCH_DRAFT_ITEMS_SUCCESS, FETCH_SHIPPING_FEE_ERROR, FETCH_SHIPPING_FEE_REQUEST, FETCH_SHIPPING_FEE_SUCCESS, REPLACE_CART_ITEM, UPDATE_CART_ITEM_QUANTITY_SUCCESS, UPDATE_CART_ITEM_SUCCESS, } from './actionTypes';
function replaceCollectionItem(state, item) {
    var _a;
    if (!((_a = state.cartItems.collection.items) === null || _a === void 0 ? void 0 : _a.length)) {
        return __assign({}, state.cartItems.collection);
    }
    var items = __spreadArray([], state.cartItems.collection.items).map(function (i) { return i.id === item.id ? item : i; });
    return __assign(__assign({}, state.cartItems.collection), { counter: items.length, items: items });
}
function replaceItem(state, item) {
    if (!state.cartItems.item.item) {
        return __assign({}, state.cartItems.item);
    }
    return __assign(__assign({}, state.cartItems.item), { item: state.cartItems.item.item.id === item.id ? item : state.cartItems.item.item });
}
var reducer = function (state, action) {
    var _a;
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case REPLACE_CART_ITEM:
            return __assign(__assign({}, state), { cartItems: {
                    collection: __assign({}, replaceCollectionItem(state, action.item)),
                    item: { status: 'loaded', item: action.item },
                } });
        case DELETE_COLLECTION_CART_ITEM:
            if (!((_a = state.cartItems.collection.items) === null || _a === void 0 ? void 0 : _a.length)) {
                return __assign({}, state);
            }
            var filteredItems = __spreadArray([], state.cartItems.collection.items).filter(function (item) { return item.id !== action.id; });
            return __assign(__assign({}, state), { cartItems: __assign(__assign({}, state.cartItems), { collection: {
                        status: 'loaded',
                        counter: filteredItems.length,
                        items: filteredItems,
                    } }) });
        case UPDATE_CART_ITEM_SUCCESS:
            return __assign(__assign({}, state), { cartItems: {
                    item: __assign({}, replaceItem(state, action.item)),
                    collection: __assign({}, replaceCollectionItem(state, action.item)),
                } });
        case UPDATE_CART_ITEM_QUANTITY_SUCCESS:
            return __assign(__assign({}, state), { cartItems: {
                    item: __assign({}, replaceItem(state, action.item)),
                    collection: __assign({}, replaceCollectionItem(state, action.item)),
                } });
        case FETCH_CART_ITEMS_REQUEST:
            return __assign(__assign({}, state), { cartItems: __assign(__assign({}, state.cartItems), { collection: __assign(__assign({}, state.cartItems.collection), { status: 'loading', items: [] }) }) });
        case FETCH_CART_ITEMS_SUCCESS:
            return __assign(__assign({}, state), { cartItems: __assign(__assign({}, state.cartItems), { collection: { status: 'loaded', counter: action.items.length, items: action.items } }) });
        case FETCH_CART_ITEMS_ERROR:
            return __assign(__assign({}, state), { cartItems: __assign(__assign({}, state.cartItems), { collection: { status: 'error', counter: null, items: [] } }) });
        case FETCH_DRAFT_ITEMS_REQUEST:
            return __assign(__assign({}, state), { draftItems: __assign(__assign({}, state.draftItems), { collection: __assign(__assign({}, state.draftItems.collection), { status: 'loading', items: [] }) }) });
        case FETCH_DRAFT_ITEMS_SUCCESS:
            return __assign(__assign({}, state), { draftItems: __assign(__assign({}, state.draftItems), { collection: { counter: action.items.length, status: 'loaded', items: action.items } }) });
        case FETCH_DRAFT_ITEMS_ERROR:
            return __assign(__assign({}, state), { draftItems: __assign(__assign({}, state.draftItems), { collection: { counter: null, status: 'error', items: [] } }) });
        case FETCH_CART_ITEM_REQUEST:
            return __assign(__assign({}, state), { cartItems: __assign(__assign({}, state.cartItems), { item: { status: 'loading', item: null } }) });
        case FETCH_CART_ITEM_SUCCESS:
            return __assign(__assign({}, state), { cartItems: __assign(__assign({}, state.cartItems), { item: { status: 'loaded', item: action.item } }) });
        case FETCH_CART_ITEM_ERROR:
            return __assign(__assign({}, state), { cartItems: __assign(__assign({}, state.cartItems), { item: { status: 'error', item: null } }) });
        case FETCH_SHIPPING_FEE_REQUEST:
            return __assign(__assign({}, state), { shippingFee: __assign(__assign({}, state.shippingFee), { status: 'loading', shippingFee: null }) });
        case FETCH_SHIPPING_FEE_SUCCESS:
            return __assign(__assign({}, state), { shippingFee: __assign(__assign({}, state.shippingFee), { status: 'loaded', shippingFee: action.data.shipping_fee }) });
        case FETCH_SHIPPING_FEE_ERROR:
            return __assign(__assign({}, state), { shippingFee: __assign(__assign({}, state.shippingFee), { status: 'error', shippingFee: null }) });
    }
    return state;
};
export default reducer;
